import { useSearchParams } from 'react-router'

import { EMPTY_STRING } from '../constants/common'
import { isMenuHomePageAvailable } from '../utils/menu'
import { getWebappLinkPrefix } from '../utils/route'

import { useInitData } from './useInitData'
import { useIsDashboardAvailable } from './useIsDashboardAvailable'

export function useRootPath() {
  const [searchParams] = useSearchParams()
  const redirect = searchParams.get('redirect') || EMPTY_STRING

  const { availableSections } = useInitData()
  const isDashboardAvailable = useIsDashboardAvailable()

  if (redirect) {
    return { hasRedirectParam: true, rootPath: redirect }
  }

  const rootPath = isMenuHomePageAvailable({
    isDashboardAvailable,
    uiSections: availableSections,
  })
    ? '/'
    : getWebappLinkPrefix(undefined, true)

  return { hasRedirectParam: false, rootPath }
}
